<template>
    <div id="root">
        <!--
          Liquid 水波纹特效参数说明：
          force           鼠标拖动力度（越大流体惯性越强），范围建议 0.5~5，默认 1.1
          intensity       颜色拖尾强度（越大墨迹越浓），范围建议 0.1~10，默认 2
          distortion      背景内容扭曲程度（越大画面越"晃"），范围建议 0~2，默认 0.4
          blend           流体颜色与页面内容的混合比例（越大越浓），范围建议 1~30，默认 5
          rainbow         是否启用彩虹色（按流动方向自动变色），默认 false
          color           非彩虹模式下的固定 RGB 色，如 [0.26,0.36,1]（蓝），rainbow=true 时忽略
          radius          指针影响半径，范围建议 0.1~1，默认 0.3
          curl            旋转力强度，范围建议 0~3，默认 1.9
          simResolution   模拟分辨率（越大越精细也越耗GPU），默认 128
          dyeResolution   颜色分辨率，默认 512
          densityDissipation 密度消散速度，默认 0.98
          velocityDissipation 速度衰减，默认 0.99
          pressure        压力强度，默认 0.8
          pressureIterations 压力计算迭代次数，默认 20
        -->
        <!-- <Liquid :force="1" :intensity="0.002" :distortion="0.2" :blend="1" :rainbow="true" style="height: 100%"> -->
            <el-container id="app-container" class="app-container">
                <router-view />
            </el-container>
        <!-- </Liquid> -->
    </div>
</template>

<script>
import request from './utils/request.js';
import Liquid from './components/Liquid.vue';
export default {
    name: 'App',
    // components: { Liquid },
    data() {
        return {
            heartbeatTimer: ''
        };
    },
    mounted() {
        console.log('app mounted');
        let token = this.$store.state.user.token;
        // this.heartbeatTimer = setInterval(this.heartbeat, 120 * 1000);
        // clearInterval(this.heartbeatTimer);
        this.heartbeat();
    },
    methods: {
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        handleChange(val) {
            console.log(val);
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        search() {
            // alert(base_server + '搜索内容~' + this.keyword);
        },
        home() {
            this.$router.push({ path: '/', params: {} });
        },
        register() {
            this.$router.push({ path: '/biz/register', params: {} });
        },
        login() {
            this.$router.push({ path: '/biz/login', params: {} });
        },
        async logout() {
            await this.$store.dispatch('user/logout');
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
        },
        heartbeat() {
            return request({
                url: '/openapi/heartbeat/base',
                method: 'post',
                data: {
                    refresh: 'y'
                }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                }
            });
        }
    }
};
</script>

<style>
html,
body,
#app,
#root {
    height: 100%;
    margin: 0;
    padding: 0;
}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    /* text-align: center; */
    /* margin-top: 60px; */
}
.app-container {
    height: 100%;
}

/* 移动端（iOS）聚焦表单控件时，字号小于 16px 会自动放大页面，这里全局固定 16px 避免缩放 */
@media (max-width: 768px) {
    .el-input__inner,
    .el-select__input,
    .el-select__placeholder,
    .el-select__selected-item,
    .el-textarea__inner {
        font-size: 16px;
    }
}
</style>
